export const accessTokenKey = 'ch_ats_access_token';

export function getAccessToken() {
  return window.localStorage.getItem(accessTokenKey);
}

export function setAccessToken(token: string) {
  window.localStorage.setItem(accessTokenKey, token);
}

export function clearAccessToken() {
  window.localStorage.removeItem(accessTokenKey);
}
